import { createContext, useContext, useState, ReactNode } from 'react';
import { PolicyListItem, SelectedYear } from '../../api/policy-list';

interface PolicyContextProps {
  selectedPolicy: PolicyListItem | null;
  setSelectedPolicy: (policy: PolicyListItem | null) => void;
  selectedYear: SelectedYear | null;
  setSelectedYear: (year: SelectedYear | null) => void;
}

const PolicyContext = createContext<PolicyContextProps | undefined>(undefined);

export const PolicyProvider = ({ children }: { children: ReactNode }) => {
  const [selectedPolicy, setSelectedPolicy] = useState<PolicyListItem | null>(
    null,
  );
  const [selectedYear, setSelectedYear] = useState<SelectedYear | null>(null);

  return (
    <PolicyContext.Provider
      value={{
        selectedPolicy,
        setSelectedPolicy,
        selectedYear,
        setSelectedYear,
      }}
    >
      {children}
    </PolicyContext.Provider>
  );
};

export const usePolicyContext = () => {
  const context = useContext(PolicyContext);
  if (!context) {
    throw new Error('usePolicyContext must be used within a PolicyProvider');
  }
  return context;
};
